import {
  isMasifiWaSticker,
  isMasifiWaUnsupportedWithReason,
} from 'dashboard/helper/masifiWhatsappQr';
import MasifiWaMessageNote from './MasifiWaMessageNote.vue';
import MasifiWaStickerBubble from './MasifiWaStickerBubble.vue';
import MasifiWaUnsupportedBubble from './MasifiWaUnsupportedBubble.vue';
import { useMasifiWaGroupLayout } from './useMasifiWaGroupLayout';

// Masifi: WhatsApp QR (F2 + F3a). Lo que Message.vue toma de un mensaje QR, en UN objeto y UN import: cada computed
// nativo lo consulta con 1 guarda de 1 línea al inicio (`if (masifiWa.x) return masifiWa.x;`) y ninguna línea de
// upstream se edita (E2E fix 8, regla 11c; core-slim T10). `undefined`/`false`/`null` = comportamiento nativo.
// - gridClass / gridTemplate / showAvatar / avatar / tooltip: avatar de los mensajes de GRUPO (useMasifiWaGroupLayout:
//   entrante a la izquierda con la foto del participante; eco de un compañero "Es de mi equipo" con su foto);
// - bubble: el sticker (F2; también el animado, que llega `isUnsupported`) y el "no se puede mostrar" con el motivo
//   del conector (F3a E2E fix 2), ambos antes del `isUnsupported` nativo;
// - note: la nota bajo la burbuja (editado / eliminado / reacción quitada, F2 ruling 10). Se monta sin props
//   (`<Component :is="masifiWa.note">`) y lee el mensaje del contexto nativo (provideMessageContext).
// Getters: cada campo lee solo su dependencia (el computed del layout o las props), así el computed nativo que lo
// consulta se recalcula únicamente cuando cambia lo suyo.
export const useMasifiWaMessage = props => {
  const layout = useMasifiWaGroupLayout(props);
  return {
    get gridClass() {
      return layout.value?.gridClass;
    },
    get gridTemplate() {
      return layout.value?.gridTemplate;
    },
    get showAvatar() {
      return !!layout.value;
    },
    get avatar() {
      return layout.value?.avatar;
    },
    get tooltip() {
      return layout.value?.tooltip;
    },
    get bubble() {
      if (isMasifiWaSticker(props.contentAttributes)) {
        return MasifiWaStickerBubble;
      }
      return isMasifiWaUnsupportedWithReason(props.contentAttributes)
        ? MasifiWaUnsupportedBubble
        : null;
    },
    note: MasifiWaMessageNote,
  };
};
